import { type ComponentProps } from 'react';

import { cn } from '@/clientOnlyUtils/cn';

export type WaveSpinnerProps = ComponentProps<'svg'> & {
  className?: string;
  size?: number;
  padding?: number;
  xControl?: number;
  yControl?: number;
  showControl?: boolean;
  blue?: boolean;
};

export const WaveSpinner = ({
  fill = 'currentColor',
  size = 100,
  padding = 0,
  xControl = 1 / 5,
  yControl = 0.32,
  showControl,
  className,
  blue,
  ...props
}: WaveSpinnerProps) => {
  const xWaveOffset = padding + size * xControl;
  const yWaveOffset = size * yControl;

  const path1 = [
    `M${padding},${size / 2}`,
    `Q ${xWaveOffset},${yWaveOffset}, ${size / 2} ${size / 2}`,
    `T${size - padding},${size / 2}`,
    `A${size / 2 - padding} ${size / 2 - padding} 0 0 1 ${padding} ${size / 2}`,
  ];

  const path2 = [
    `M${padding},${size / 2}`,
    `Q ${xWaveOffset},${size - yWaveOffset}, ${size / 2} ${size / 2}`,
    `T${size - padding},${size / 2}`,
    `A${size / 2 - padding} ${size / 2 - padding} 0 0 1 ${padding} ${size / 2}`,
  ];
  const animationValues = [path1, path2, path1].join('; ');

  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox={`0 0 ${size} ${size}`}
      preserveAspectRatio="xMidYMid"
      shapeRendering="auto"
      className={cn('m-auto block bg-transparent', className, blue ? 'text-[#3c51a3]' : undefined)}
      {...props}>
      <path d={path1.join(' ')} fill={fill}>
        <animate
          attributeName="d"
          repeatCount="indefinite"
          dur="0.7575757575757576s"
          calcMode="spline"
          keyTimes="0;0.5;1"
          values={animationValues}
          keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
        />
      </path>
      {showControl && <circle r={5} cx={xWaveOffset} cy={yWaveOffset} fill="red" />}
    </svg>
  );
};
